import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import RoutingUtils from '../../../shared/utils/utils-routing';
import { MATERIAL_ICON_VIDEO } from '../../../shared/common/Button/Icon';
import VideoPlayerPopup from '../../../shared/components/VideoPlayerPopup';
import { CreditDropdown } from './CreditDropdown';
import { Button, ButtonSize, ButtonTheme } from '../../../shared/common/Button';
import { ProductOut } from '../../../store/api';
import { useLocation } from 'react-router';
import { CreditSummaryOut } from '../../../store/apiLibx';
import { AuthenticationState } from '../../../store/authentication/state';
import { useTranslation } from 'react-i18next';

const StButton = styled(Button)`
    margin-left: 5px;
`;

const ButtonLine = styled.div.attrs({ 'data-displayname': 'HeaderButtonLine' })`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 62px;
    align-items: center;
`;

interface Props {
    purchaseCredits: (message: string) => void;
    taxName: string;
    currency: string;
    credits: CreditSummaryOut;
    products: ProductOut[];
    authentication: AuthenticationState;
}

export const YourTitlesHeader = (props: Props) => {
    const { t } = useTranslation();
    const { search } = useLocation();

    const [isFixed, setIsFixed] = useState(false);
    const [showIntroVideo, setShowIntroVideo] = useState(false);
    const [urlParamHandled, setUrlParamHandled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if ((window.scrollY || window.pageYOffset) > 50) {
                if (!isFixed) {
                    setIsFixed(true);
                }
            }
            setIsFixed(false);
        };
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isFixed]);

    useEffect(() => {
        if (search.includes('intro') && !urlParamHandled) {
            setShowIntroVideo(true);
            setUrlParamHandled(true);
        }
    }, [search, urlParamHandled]);

    const availableCredits = props.credits.available ?? 0;
    const isCreateNewEnabled = availableCredits > 0;

    return (
        <ButtonLine>
            <VideoPlayerPopup
                showVideo={showIntroVideo}
                hideVideo={() => setShowIntroVideo(false)}
                vimeoId={272097594}
            />
            <Button
                text={t('yourLocalContent.localContentCollection.introductionAndTraining')}
                icon={MATERIAL_ICON_VIDEO}
                onClick={() => setShowIntroVideo(true)}
                key="intro-video-button"
                size={ButtonSize.LARGE}
                theme={ButtonTheme.POSITIVE_INVERT}
            />
            <div key="spacer" style={{ flexGrow: 1 }} />

            <CreditDropdown
                credits={props.credits}
                purchaseCredits={props.purchaseCredits}
                currency={props.currency}
                taxName={props.taxName}
            />
            <StButton
                disabled={!isCreateNewEnabled}
                size={ButtonSize.LARGE}
                text={t('yourLocalContent.yourTitles.createNewTitle')}
                onClick={event => {
                    event.preventDefault();
                    RoutingUtils.pushUrl('/localcontent/products/new');
                }}
            />
        </ButtonLine>
    );
};
